import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {Card, Col, Container, Row} from "react-bootstrap";
import RecommendedChannels from "../components/news/RecommendedChannels";
import SEO from "../components/seo/SEO";
import { fetchInternalNews } from '../http/internalNewsAPI';

const NewsListPage = () => {
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;

        fetchInternalNews()
            .then((data) => {
                if (!mounted) return;
                setNewsList(Array.isArray(data) ? data : []);
                setError("");
            })
            .catch(() => {
                if (!mounted) return;
                setError("Failed to load news");
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, []);

    return (
<>


    <SEO
        title="Virtalibry News & Updates – Platform Improvements, Tools & Insights"
        description="Follow the latest Virtalibry news, platform updates and feature improvements. Learn about new tools, system changes and insights designed to help authors and readers work more effectively."
        keywords="Virtalibry updates, platform news, author tools updates, book marketing platform news, Virtalibry features, product updates"
        url="https://virtalibry.com/news"
        canonical="https://virtalibry.com/news"
        image="https://virtalibry.com/face/why_love_is_gold_new.png"
        type="website"

        webPage={{
            name: "Virtalibry News & Updates",
            url: "https://virtalibry.com/news",
            description:
                "Official news and updates from Virtalibry, covering new features, system improvements, tools and insights for authors, reviewers and platform partners.",
        }}

        breadcrumb={[
            { name: "Home", item: "https://virtalibry.com" },
            { name: "News", item: "https://virtalibry.com/news" }
        ]}

        additionalSchemas={[
            {
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                name: "Virtalibry News & Updates",
                url: "https://virtalibry.com/news",
                description:
                    "A collection of official announcements, feature updates and product insights published by the Virtalibry team.",
            }
        ]}
    />




    <Container fluid className="px-3 mt-3 mb-3">
    <Row>
        <Col xs={12} sm={12} md={12} className="ms-0"></Col>
    </Row>
        <Row className="justify-content-start">
            <Col xs={12} md={9} lg={9}>
                <Card className="shadow-sm rounded p-3 bg-white">

    <div>
        <h1 className="fs-5">News & Updates</h1>
        {loading && <p className="small text-muted mb-2">Loading news...</p>}
        {error && <p className="small text-danger mb-2">{error}</p>}
        {!loading && !error && newsList.length === 0 && (
            <p className="small text-muted mb-0">No news yet.</p>
        )}
        <ul className="list-group">
            {newsList.map((news) => (
                <li
                    key={news.id}
                    className="list-group-item list-group-item-action"
                    style={{ cursor: 'pointer' }}
                >
                    <Link
                        to={`/news/${news.slug}`}
                        className="text-decoration-none text-reset"
                    >
                        <div className="clearfix">
                            <img
                                src={news.image}
                                alt={news.title}
                                style={{
                                    float: 'left',
                                    width: '22%',
                                    maxWidth: '90px',
                                    maxHeight: '90px',
                                    objectFit: 'cover',
                                    borderRadius: '6px',
                                    marginRight: '12px',
                                    marginBottom: '6px',
                                    flexShrink: 0
                                }}
                            />
                            <div>
                                <h6 className="mb-0">{news.title}</h6>
                                <span
                                    className="text-muted small fst-italic"
                                    style={{
                                        lineHeight: '1.4',
                                        fontSize: '13px'
                                    }}
                                >
                            {news.date}
                        </span>
                                <p className="small text-muted mb-0">{news.summary}</p>
                            </div>
                        </div>
                    </Link>
                </li>
            ))}
        </ul>

    </div>

                </Card>
            </Col>
            <Col md={3} lg={3} className="d-none d-md-block">
                <Card className="shadow-sm rounded p-3 bg-white">
                    <RecommendedChannels />
                </Card>
            </Col>
        </Row>
    </Container>
    </>
    );
};

export default NewsListPage;
